import { Button } from 'components/atoms';
import WarningPopup from 'components/molecules/popup/warning-popup/WarningPopup';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PiNotepad, PiPaperPlaneTilt } from 'react-icons/pi';
import { useGetLabel } from 'services/labels';
import { LABEL_STATUS } from 'services/labels/types';
import { STATUS } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IFormSubmitButtonsProps {
  statusName?: string;
}

const FormSubmitButtons = <FormType,>({ statusName = 'statusId' }: IFormSubmitButtonsProps) => {
  const { t } = useTranslation();

  const label = useGetLabel(false);

  const {
    initialValues,
    status,
    setFieldValue,
    handleSubmit,
  }: IFormikContextType<FormType & Record<string, STATUS>> = useFormikContext<
    FormType & Record<string, STATUS>
  >();

  const [open, setOpen] = useState(false);

  const onSubmit = async (status: STATUS) => {
    await setFieldValue(statusName, status);
    handleSubmit();
  };

  return (
    <div className="flex gap-2">
      {initialValues[statusName] === STATUS.draft && (
        <Button
          // isClear
          onlyIcon
          variant={BUTTON_VARIANT.background}
          onClick={() => onSubmit(STATUS.draft)}
          isLoading={status?.isLoading}
          outsideChildren={<Button.Description description={t('button.save-as-draft')} />}
        >
          <Button.Icon icon={<PiNotepad />} />
        </Button>
      )}

      <Button
        onlyIcon
        variant={BUTTON_VARIANT.submit}
        onClick={() => onSubmit(STATUS.notVerified)}
        isLoading={status?.isLoading}
        disabled={label.data?.labelStatus === LABEL_STATUS.draft}
        outsideChildren={<Button.Description description={t('button.send-to-verification')} />}
        id="form-submit-step-tab"
      >
        <Button.Icon icon={<PiPaperPlaneTilt />} />
      </Button>

      <WarningPopup
        title={t('button.send-to-verification')}
        message={t('popup.send-to-verification-description')}
        open={open}
        confirmButtonVariant={BUTTON_VARIANT.submit}
        onConfirm={(actions) => {
          handleSubmit();
          actions.close();
        }}
      />
    </div>
  );
};

export default FormSubmitButtons;
